import type { MenuDataItem } from '@ant-design/pro-components';

export type OmsMenuDataItem = {
  path?: string;
  name?: string;
  icon?: MenuDataItem['icon'];
  key?: string;
  children?: OmsMenuDataItem[];
  routes?: OmsMenuDataItem[];
  [key: string]: unknown;
};

const directOrderPaths = new Set([
  '/overseas-warehouse/direct-order',
  '/overseas-warehouse/direct-orders',
]);

const menuGroupPathMap: Record<string, string> = {
  '/domestic-warehouse': '/domestic-warehouse-menu',
  '/overseas-warehouse': '/overseas-warehouse-menu',
};

export const getOmsMenuSelectionState = (pathname?: string) => {
  const cleanPath = (pathname || '').split('?')[0].split('#')[0];

  if (cleanPath === '/domestic-warehouse/product') {
    return {
      openKeys: [],
      selectedKeys: ['/domestic-warehouse/product'],
    };
  }

  if (directOrderPaths.has(cleanPath)) {
    return {
      openKeys: ['/first-leg-orders'],
      selectedKeys: [cleanPath],
    };
  }

  return {};
};

export const buildOmsMenuData = (
  menuData: OmsMenuDataItem[] = [],
  options: { firstLegIcon?: MenuDataItem['icon'] } = {},
) => {
  const nextMenuData: MenuDataItem[] = [];
  let firstLegMenu: MenuDataItem | undefined;
  const toMenuDataItem = (item: OmsMenuDataItem): MenuDataItem => {
    const { children, routes, ...restItem } = item;
    const childItems = children || routes;
    return {
      ...restItem,
      ...(childItems
        ? { children: childItems.map((child) => toMenuDataItem(child)) }
        : {}),
    };
  };

  for (const item of menuData) {
    const menuGroupPath = item.path ? menuGroupPathMap[item.path] : undefined;

    if (item.path !== '/overseas-warehouse') {
      nextMenuData.push(
        toMenuDataItem(
          menuGroupPath
            ? {
                ...item,
                path: menuGroupPath,
                key: menuGroupPath,
              }
            : item,
        ),
      );
      continue;
    }

    const children = item.children || item.routes || [];
    const firstLegChildren = children.filter((child) =>
      directOrderPaths.has(child.path || ''),
    );
    const overseasChildren = children.filter(
      (child) => !directOrderPaths.has(child.path || ''),
    );

    if (firstLegChildren.length > 0) {
      firstLegMenu = {
        path: '/first-leg-orders',
        name: '头程订单',
        icon: options.firstLegIcon,
        children: firstLegChildren.map((child) => toMenuDataItem(child)),
      };
    }

    nextMenuData.push(
      toMenuDataItem({
        ...item,
        path: menuGroupPath,
        key: menuGroupPath,
        children: overseasChildren,
      }),
    );
  }

  if (!firstLegMenu) {
    return nextMenuData;
  }

  const overseasIndex = nextMenuData.findIndex(
    (item) => item.path === menuGroupPathMap['/overseas-warehouse'],
  );
  if (overseasIndex < 0) {
    return [...nextMenuData, firstLegMenu];
  }

  return [
    ...nextMenuData.slice(0, overseasIndex),
    firstLegMenu,
    ...nextMenuData.slice(overseasIndex),
  ];
};
